<template>
  <modal
    width="35"
    :show-modal="showModal"
    :id="id"
    @close-modal="$emit('close-modal')"
  >
    <div class="delete-modal">
      <p class="text-center my-4">
        Confirm you want to send a fulfillment Receipt Request To:
      </p>

      <div>
        <div style="border: 1px solid #fcc210">
          <div
            class="flex relative h-16 gap-4 items-center"
            style="background: #fcc2101a"
          >
            <svg
              style="position: absolute; top: 0"
              width="64"
              height="68"
              viewBox="0 0 64 68"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 0H64V60.4444L30.5672 68L0 60.4444V0Z"
                fill="#FCC210"
              />
              <path
                d="M40.4375 27.1875C40.4375 24.9497 39.5486 22.8036 37.9662 21.2213C36.3839 19.6389 34.2378 18.75 32 18.75C29.7622 18.75 27.6161 19.6389 26.0338 21.2213C24.4514 22.8036 23.5625 24.9497 23.5625 27.1875C23.5625 30.6488 26.3319 35.16 32 40.5637C37.6681 35.16 40.4375 30.6488 40.4375 27.1875ZM32 43.125C25.1244 36.8756 21.6875 31.5619 21.6875 27.1875C21.6875 24.4525 22.774 21.8294 24.708 19.8955C26.6419 17.9615 29.265 16.875 32 16.875C34.735 16.875 37.3581 17.9615 39.292 19.8955C41.226 21.8294 42.3125 24.4525 42.3125 27.1875C42.3125 31.5619 38.8756 36.8756 32 43.125Z"
                fill="white"
              />
              <path
                d="M32 28.125C32.4973 28.125 32.9742 27.9275 33.3258 27.5758C33.6775 27.2242 33.875 26.7473 33.875 26.25C33.875 25.7527 33.6775 25.2758 33.3258 24.9242C32.9742 24.5725 32.4973 24.375 32 24.375C31.5027 24.375 31.0258 24.5725 30.6742 24.9242C30.3225 25.2758 30.125 25.7527 30.125 26.25C30.125 26.7473 30.3225 27.2242 30.6742 27.5758C31.0258 27.9275 31.5027 28.125 32 28.125ZM32 30C31.0054 30 30.0516 29.6049 29.3483 28.9017C28.6451 28.1984 28.25 27.2446 28.25 26.25C28.25 25.2554 28.6451 24.3016 29.3483 23.5983C30.0516 22.8951 31.0054 22.5 32 22.5C32.9946 22.5 33.9484 22.8951 34.6516 23.5983C35.3549 24.3016 35.75 25.2554 35.75 26.25C35.75 27.2446 35.3549 28.1984 34.6516 28.9017C33.9484 29.6049 32.9946 30 32 30ZM42.125 35.625L45.125 43.125H36.6875V41.25H27.3125V43.125H18.875L21.875 35.625H42.125ZM40.1056 35.625H23.8944L21.6444 41.25H42.3556L40.1056 35.625Z"
                fill="white"
              />
            </svg>
            <span style="margin-left: 5rem">Deliver To: </span>
          </div>
          <div class="p-4">
            <address>
              {{
                booking.receiver
                  ? formatAddress(booking.receiver.address)
                  : "N/A"
              }}, <br />
              {{
                booking.receiver.address ? booking.receiver.address.name : ""
              }}
            </address>
            <hr />
            <p class="mt-3 font-semibold">
              {{ booking.receiver.contactName }}
              <span class="text-red">{{
                booking.receiver.mobile
              }}</span>
              <span class="block text-red">{{
                booking.receiver.email
              }}</span>
            </p>
          </div>
          <div class="py-2 px-4" style="border-top: 1px solid #fcc210">
            <!-- <p>Friday, 29th April 2022</p>
              <p>Preferred time: 6:00AM - 5:00PM</p> -->
            <div class="flex gap-2 w-100">
              <span>Delivery Status:</span>
              <div>
                <el-select v-model="reason" placeholder="-- Select or Input --">
                  <el-option label="In good condition" value="In good condition"> </el-option>
                  <el-option label="Damaged" value="Damaged"> </el-option>
                  <el-option label="Others" value="others"> </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex gap-2 w-100">
              <span>Receipt code:</span>
              <span class="text-primary-yellow">******</span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <p class="mt-4">
          Enter the delivery code sent to the recipient to confirm fulfillment
        </p>
        <div class="authentication-code-area mt-3 mx-auto sm:w-full">
          <div class="single-code">
            <input
              type="text"
              class="single-code--input no-outline"
              maxlength="1"
              pattern="[a-zA-Z0-9]*"
              v-model="authenticationCode.first"
              @keyup="changeInputField"
              autofocus
            />
            <input
              type="text"
              class="single-code--input no-outline"
              maxlength="1"
              pattern="[a-zA-Z0-9]*"
              v-model="authenticationCode.second"
              @keyup="changeInputField"
            />
            <input
              type="text"
              class="single-code--input no-outline"
              maxlength="1"
              pattern="[a-zA-Z0-9]*"
              v-model="authenticationCode.third"
              @keyup="changeInputField"
            />
            <input
              type="text"
              class="single-code--input no-outline"
              maxlength="1"
              pattern="[a-zA-Z0-9]*"
              v-model="authenticationCode.fourth"
              @keyup="changeInputField"
            />
          </div>
        </div>
      </div>
      <div class="flex w-100 justify-end my-4">
        <button @click="$emit('close-modal')" class="mr-5">Cancel</button>
        <base-button
          text="Confirm"
          :loading="loading"
          @click="acknowledgeRequest()"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import changeInputField from "@/mixins/changeInput";

export default {
  components: {},
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    booking: {
      type: Object,
      required: true,
    },
    messageId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      showRequestSentModal: false,
      fromOrgid: null,
      toOrgId: null,
      toUserId: null,
      id: "cancel-reason",
      authenticationCode: {
        first: "",
        second: "",
        third: "",
        fourth: "",
      },
      reason: ""
    };
  },
  mixins: [changeInputField],
  computed: {
    orgid() {
      return this.$store.state.authentication.quantumOrganizationId;
    },
    userid() {
      return this.$store.state.authentication.quantumUserId;
    },
  },
  watch: {
    showModal(){
       console.log("confirm fufilment code", this.booking)
    }
  },
  methods: {
    async acknowledgeRequest() {
      try {
        let code =
          this.authenticationCode.first +
          this.authenticationCode.second +
          this.authenticationCode.third +
          this.authenticationCode.fourth;

        this.loading = true;

        let payload = {
          moduleId: this.booking?.shipingId,
          token: code,
          type: "process_fulfillment",
        };

        const response = await this.$_acknowledgeRequest(payload);

        if (response.data.success) {
          let payloadMS = {
            status: "accepted",
            isRead: true,
          };

          await this.$_acknowledgeRequestMS(this.messageId, payloadMS);
        }
        
        this.authenticationCode.first = ""
        this.authenticationCode.second = ""
        this.authenticationCode.third = ""
        this.authenticationCode.fourth = ""

        this.$emit("refetch-bookings");

        this.generateToast(
          response.data.message + ". Process fulfillment successful.",
          "success"
        );

        this.$emit("close-modal");
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async sendProcess() {
      let postMessage = {
        app: "muleex",
        event: "process:fulfillment",
        message: {
          userId: this.$store.state.authentication.userId,
          shippingId: this.booking.id,
          module: "shippings",
          moduleId: "5b80ecd4-73d5-4440-bdcf-40b76ea3edcc",
        },
      };

      this.$socket.emit("makeMessage", postMessage);

      this.generateToast("Booking Fulfilment request sent", "success");
      this.loading = false;
      this.$emit("show-request-sent");
      this.$emit("close-modal");
    },

    completedSubmission() {
      this.reason = "";
      this.$emit("booking-subaction-completed");
      this.$emit("close-modal", this.id);
    },
  },
};
</script>

<style scoped>
.authentication-screen-wrapper {
  width: 90%;
  margin: 0 auto;
}
.auth-code-form {
  width: 100%;
}
.single-code--input {
  width: 3.5rem;
  height: 3rem;
  padding: 10px;
  background: #ffffff;
  border: 1px solid rgba(82, 82, 82, 0.5);
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 1rem;
  margin-right: 1rem;
}
.single-code--input[type="text"] {
  font-size: 2.3rem;
  text-align: center;
  font-weight: bold;
  color: rgba(82, 82, 82, 0.3);
}
</style>
